import { getJson } from "./getJson";

export async function getBonusQReport(param: string) {
  if (param) {
    return getJson(`/internal-api/employee/statistics/quarter?year=${param}`);
  }
}
